import { getFsComponentPropsUtil } from '@utils/fullstory';

export function useFullstoryElement(): Record<string, anyOk> {
  return {
    getFsComponentProps: getFsComponentPropsUtil,
  };
}
